/**
 * BID LMS V3 - Participant Portal
 *
 * Root layout with ParticipantShell and nested route outlet.
 * Individual pages are mounted via <Outlet /> when routes match.
 */

import { Outlet } from 'react-router';
import { ParticipantShell } from './components/ParticipantShell';

function App() {
  return (
    <ParticipantShell>
      <Outlet />
    </ParticipantShell>
  );
}

export default App;
